import { useEffect } from "react";

import { useMediaQuery } from "@mui/material";

import { useAppDispatch, useAppSelector } from "app/hooks";

import { coreActions } from "features/core/store/slice";

import { userSelectors } from "../store/selectors";
import { ColorScheme } from "../types/ColorScheme";

export const useUserSettingColorScheme = () => {
    const dispatch = useAppDispatch();

    // user settings
    const userSettingsColorScheme = useAppSelector(
        userSelectors.selectColorScheme,
    );

    // apply color scheme
    const systemSelectedColorScheme = useMediaQuery(
        "(prefers-color-scheme: dark)",
    )
        ? "dark"
        : "light";

    useEffect(() => {
        switch (userSettingsColorScheme) {
            case ColorScheme.Light:
                dispatch(coreActions.setThemePaletteMode("light"));
                break;

            case ColorScheme.Dark:
                dispatch(coreActions.setThemePaletteMode("dark"));
                break;

            case ColorScheme.System:
            default:
                dispatch(
                    coreActions.setThemePaletteMode(systemSelectedColorScheme),
                );
                break;
        }
    }, [userSettingsColorScheme, systemSelectedColorScheme]);
};
